import cn from 'classnames';
import { FC, HTMLProps, useCallback, useEffect } from 'react';
import { FaFilter } from 'react-icons/fa6';
import { Button } from '../../../components/button/button';
import { Divider } from '../../../components/divider/divider';
import { useLang } from '../../../hooks/use-lang';
import { useQueryParams } from '../../../hooks/use-query-params';
import { useToggle } from '../../../hooks/use-toggle';
import { Tooltip } from '../../tooltip/tooltip';
import s from './table-filter.module.css';
import { TableSorter } from './table-sorter/table-sorter';

interface Props extends HTMLProps<HTMLDivElement> {
  onSubmit: () => void;
  onReset: () => void;
  name: string;
}

export const TableFilter: FC<Props> = (props) => {
  const { className, children, onReset, onSubmit, name } = props;
  const { t } = useLang();

  const params = useQueryParams().getQueryParams();

  const isActive = params[name] || params[`${name}-check`];

  const [open, , setOpen] = useToggle();

  const handleReset = useCallback(() => {
    onReset();
    setOpen(false);
  }, [onReset, setOpen]);

  const handleSubmit = useCallback(() => {
    onSubmit();
    setOpen(false);
  }, [onSubmit, setOpen]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && open) {
        handleSubmit();
      }
      if (e.key === 'Escape' && open) {
        setOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleReset, handleSubmit, open, setOpen]);

  const isCheckInOuts = location.pathname.includes('check-in-check-out');
  return (
    <div className={s.feature}>
      {!isCheckInOuts && <TableSorter name={name} />}
      <Tooltip
        triggerWrapperClassName={cn(s.trigger, !isActive && s.inActive)}
        trigger={<FaFilter />}
        optionsWrapperClassName={cn(s.options, className)}
        open={open}
        onOpen={setOpen}
        offset={12}
      >
        <>
          {children}
          <Divider />
          <div className={s.actions}>
            <Button variant="secondary" onClick={handleReset}>
              {t('Сбросить')}
            </Button>
            <Button onClick={handleSubmit}>{t('Готово')}</Button>
          </div>
        </>
      </Tooltip>
    </div>
  );
};
